import { FunctionComponent, useEffect, useState } from 'react';
import { Widget } from '../../views/Dashboard';
import axios, { AxiosResponse } from 'axios';
import { CellPlugin } from '@react-page/editor';
import { WidgetTable } from './partials/WidgetTable';
import { Localization } from '../../framework/localization/Localization';

const Areas: FunctionComponent<any> = (props: any) => {
  const headers = [
    { label: 'Area', key: 'area', width: 3 },
    { label: 'Description', key: 'description', width: 9 },
  ];
  const [response, setResponse] = useState<any>({});
  const getData = async () => {
    const date = new Date();
    const millisec = date.getTime();
    const id = millisec.toString(36);
    let payload = {
      control: {
        IptorAPI: '1.0',
        method: 'areas.get',
        id: id,
      },
    };
    let res = await axios
      .request({
        url: '/aperio/api/service',
        data: payload,
        method: 'POST',
      })
      .catch((err) => {
        console.error(`Error from Areas ${err}`);
      });
    const data = {
      rows: (res as AxiosResponse)?.data?.data?.items,
    };
    setResponse(data || {});
  };

  useEffect(() => {
    getData();
  }, [props]);

  return (
    <WidgetTable
      title={props.title || Localization.instance.getString('DASHBOARD_Areas')}
      headers={headers}
      rows={response.rows}
    />
  );
};

const areas: CellPlugin = {
  Renderer: ({ data }: any) => {
    return (
      <div className={'card'} style={{ height: data.height || '200px' }}>
        <Widget height={'auto'} className={'low-pad'}>
          <Areas title={data.title} height={data.height} />
        </Widget>
      </div>
    );
  },
  id: 'alerts-table-new',
  title: 'Areas',
  description: 'Display areas from DC1',
  version: 1,
  controls: {
    type: 'autoform',
    columnCount: 1,
    schema: {
      properties: {
        title: {
          type: 'string',
        },
        height: {
          type: 'string',
        },
      },
      required: [],
    },
  },
};
export default areas;
